import { useState } from "react";
import { Box, Paper, Tab, Tabs, Typography, useTheme } from "@mui/material";
import { AtomicBidCreator } from "@/grid/spreadsheet/bidConsumer/components/AtomicBidCreator";

/**
 * BidPreviewPanel — tabbed view showing wizard-configured and AI-generated bid previews.
 *
 * Props:
 *  - wizardBidData: ApiBid | null — bid from wizard configuration
 *  - llmBidData: ApiBid | null — bid from AI generation
 *  - highlightDepth: number | null — row highlighting depth
 *  - onWizardBidChange: (bid) => void
 *  - onLlmBidChange: (bid) => void
 *  - onSubmitSuccess: () => void
 */
export default function BidPreviewPanel({
    wizardBidData,
    llmBidData,
    highlightDepth,
    onWizardBidChange,
    onLlmBidChange,
    onSubmitSuccess,
}) {
    const theme = useTheme();
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Paper
            sx={{
                height: "100%",
                overflow: "hidden",
                borderRadius: 3,
                background: theme.palette.background.default,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Tabs
                value={activeTab}
                onChange={(_, newVal) => setActiveTab(newVal)}
                sx={{
                    minHeight: 42,
                    px: 2,
                    pt: 1,
                    "& .MuiTab-root": {
                        minHeight: 36,
                        textTransform: "none",
                        fontSize: 14,
                    },
                }}
            >
                <Tab label="AI Generated Bid" />
                <Tab label="Manually Configured Bid" />
            </Tabs>

            <Box sx={{ flex: 1, minHeight: 0, overflow: "auto", pr: 3 }}>
                {activeTab === 0 && (
                    <AtomicBidCreator
                        highlightDepth={highlightDepth}
                        initialBid={llmBidData}
                        onSubmitSuccess={onSubmitSuccess}
                        onBidChange={onLlmBidChange}
                    />
                )}
                {activeTab === 1 && (
                    <AtomicBidCreator
                        highlightDepth={highlightDepth}
                        initialBid={wizardBidData}
                        onSubmitSuccess={onSubmitSuccess}
                        onBidChange={onWizardBidChange}
                    />
                )}
            </Box>
        </Paper>
    );
}
